import React, { useState, useContext, useEffect } from 'react'
import { Navigate } from 'react-router-dom';
import { Form, Button, Flag, Message } from 'semantic-ui-react'
import GlobalContext from '../../../contexts/GlobalContext';
import API, { ResponseManagement, ErrorManagement } from '../../../API';
import InputText from '../../FormInputCustomer/InputText/InputText';
import InputSelect from '../../FormInputCustomer/InputSelect/InputSelect';
import InputSelectDate from '../../FormInputCustomer/InputSelect/InputSelectDate';
import {isMobile} from "react-device-detect";
import Utility from '../../../Utility';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { SET_USER } from '../../../contexts/GlobalType';
import './FormPersonalInformation.css';

const FormPersonalInformation = (props) => {
  const [globalContext, dispatch] = useContext(GlobalContext);
  const [redirectState, setRedirectState] = useState(false);
  const [listOptionsState, setListOptionsState] = useState({});
  const [errorState, setErrorState] = useState({});
  const [civilityState, setCivilityState] = useState('');
  const [societyState, setSocietyState] = useState('');
  const [lastNameState, setLastNameState] = useState('');
  const [firstNameState, setFirstNameState] = useState('');
  const [nationalityState, setNationalityState] = useState('');
  const [languageState, setLanguageState] = useState('');
  const [birthPlaceState, setBirthPlaceState] = useState('');
  const [birthDateState, setBirthDateState] = useState('');

  useEffect(() => {
    let listInput = getInput();
    let listState = {
      redirect: false,
      error: {}
    };
    
    for (let index in listInput) {// eslint-disable-line no-unused-vars
      let input = listInput[index];
      listState[input.name] = input.valueDefault;
      listState.error[input.name] = false;
    }

    setRedirectState(listState.redirect);
    setErrorState(listState.error);

    let listOptions = {
      nationalities: getListOptionsNationality(),
      languages: getListOptionsLanguage(),
      civilitys: Utility.getListCivility(globalContext.translations)
    }
    setListOptionsState(listOptions);
    
  }, []);// eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    updateDate(globalContext.user);
  }, [globalContext.user]);
  // eslint-disable-line react-hooks/exhaustive-deps

  /**
   * Retourne la liste des options des nationalités
   */
  const getListOptionsNationality = () => {
    let listOptions = [];
    if (Array.isArray(globalContext.countries) === true) {
      for (let i = 0; i < globalContext.countries.length; i++) {
        let { id, iso, name } = globalContext.countries[i];
        let codeIso = Utility.lowerCase(iso);
        if (Utility.testFlag(codeIso) === true) {
          listOptions.push({
            key: iso,
            text: [<Flag name={codeIso} key={id + 'Flag'} />, name],
            value: iso,
          });
        }
      }
    }

    return listOptions;
  }

  /**
   * Retourne la liste des options des langues
   */
  const getListOptionsLanguage = () => {
    let listOptions = [];
    if (Array.isArray(globalContext.languages) === true) {
      let listAdressPays = {}
      for (let j = 0; j < globalContext.countries.length; j++) {
        listAdressPays[globalContext.countries[j].id] = j;
      }
      for (let i = 0; i < globalContext.languages.length; i++) {
        let { id, iso, originalName } = globalContext.languages[i];
        if (Utility.testFlag(iso) === true) {
          listOptions.push({
            key: iso,
            text: [<Flag name={Utility.lowerCase(iso)} key={id + 'Flag'} />, originalName],
            value: iso,
          });
        }
      }
    }
    
    return listOptions;
  }

  /**
   * Evenet Submit form
   * @param Object event
   */
  const handleSubmit = async (event) => {
    let dataForm = new FormData(event.target.closest('form')),
      errorTemp = Object.assign({}, errorState),
      errorDetect = false,
      listInput = getInput(),
      data = Object.assign({}, globalContext.user);

    for (let property in globalContext.user) {// eslint-disable-line no-unused-vars
      let newValue = dataForm.get('input_' + property);
      if (newValue !== null) {
        if (property === 'langue') {
          newValue = parseInt(newValue);
        }

        data[property] = newValue;
        if( listInput[property].required == true ){
          let test = Utility.checkValue(listInput[property].name, newValue, listInput[property].typePattern);
          errorTemp[property] = test.error
          if (errorTemp[property] === true) {
            errorDetect = true;
          }
        }
      }
    }
    
    setErrorState(errorTemp);
    updateDate(data);

    if (errorDetect === false) {
      //data = new URLSearchParams(data);
      
      API.postForm(Utility.getUrlAjax() + '/updateUserAction', data)
        .then(response => {
          ResponseManagement(response,
            () => {
              updateDate(response.data.data.user);
              dispatch({ type: SET_USER, payload: response.data.data.user });
              props.handleChangePage('addressCP', 'after');
              if (response.data.message) {
                toast.success(response.data.message);
              }
            },
            () => { }
          );
        })
        .catch(error => {
          console.error(error)
          ErrorManagement(error, () => { });
        })
    } else {
      toast.error(globalContext.translations.msgErrorEnterAllInput);
    }
  }

  /**
   * Retoune la liste des inputs
   */
  const getInput = () => {
    return {
      civility: {
        name: 'civility',
        //required: true,
        required: globalContext.fieldResidentParam.resident?.qualite === "mandatory",
        typePattern: 'notNull',
        valueDefault: '',
        disabled: globalContext.fieldResidentParam.resident?.qualite === "mandatory" && civilityState != '' ? props.hasBookingCheckInState.hasBookingCheckIn : false
      },
      society: {
        name: 'society',
        required: false,
        typePattern: false,
        valueDefault: ''
      },
      lastName: {
        name: 'lastName',
        required: true,
        typePattern: 'notNull',
        valueDefault: '',
        disabled: lastNameState != '' ? props.hasBookingCheckInState.hasBookingCheckIn : false
      },
      firstName: {
        name: 'firstName',
        //required: true,
        required: globalContext.fieldResidentParam.resident?.prenom === "mandatory",
        typePattern: 'notNull',
        valueDefault: '',
        disabled: globalContext.fieldResidentParam.resident?.prenom === "mandatory" && firstNameState != '' ? props.hasBookingCheckInState.hasBookingCheckIn : false
      },
      nationality: {
        name: 'nationality',
        //required: true,
        required: globalContext.fieldResidentParam.resident?.nationalite === "mandatory",
        typePattern: 'notNullSelectPays',
        valueDefault: '',
        disabled: globalContext.fieldResidentParam.resident?.nationalite === "mandatory" && nationalityState != '' && nationalityState != '00' && nationalityState != 0 ? props.hasBookingCheckInState.hasBookingCheckIn : false
      },
      language: {
        name: 'language',
        //required: true,
        required: globalContext.fieldResidentParam.resident?.id_langue_fich_client === "mandatory",
        typePattern: 'notNull',
        valueDefault: 0,
        disabled: globalContext.fieldResidentParam.resident?.id_langue_fich_client === "mandatory" && languageState != '' ? props.hasBookingCheckInState.hasBookingCheckIn : false
      },
      birthPlace: {
        name: 'birthPlace',
        //required: true,
        required: globalContext.fieldResidentParam.resident?.lieu_naissance === "mandatory",
        typePattern: 'notNull',
        valueDefault: '',
        disabled: globalContext.fieldResidentParam.resident?.lieu_naissance === "mandatory" && birthPlaceState != '' ? props.hasBookingCheckInState.hasBookingCheckIn : false
      },
      birthDate: {
        name: 'birthDate',
        //required: true,
        required: globalContext.fieldResidentParam.resident?.date_naissance === "mandatory",
        typePattern: 'date',
        valueDefault: '',
        disabled: globalContext.fieldResidentParam.resident?.date_naissance === "mandatory" && birthDateState != '' && birthDateState != '0000-00-00' ? props.hasBookingCheckInState.hasBookingCheckIn : false
      }
    }
  }

  /**
   * Gere la redirection vers le stage suivant
   */
  const renderRedirectAccount = () => {
    if (redirectState) {
      return <Navigate to={Utility.getUrlPage(globalContext, 'addressCP')} />
    }
  }

  /**
   * Mise a jout des states
   * @param {*} data 
   */
  const updateDate = (data) => {
    let errorTemp = Object.assign({}, errorState);
    let listInput = getInput();
    for (let index in listInput) {// eslint-disable-line no-unused-vars

      let input = listInput[index]
      let theValue = data[input.name]

      if( input.required == true ){
        let test = Utility.checkValue(input.name, theValue, input.typePattern)
        //errorTemp[test.target] = test.error

        input.name = test.target
        theValue = test.value
      }

        switch (input.name) {
          case 'civility':
            setCivilityState(theValue);
            break;
          case 'society':
            setSocietyState(theValue);
            break;
          case 'lastName':
            setLastNameState(theValue);
            break;
          case 'firstName':
            setFirstNameState(theValue);
            break;
          case 'nationality':
            setNationalityState(theValue);
            break;
          case 'language':
            setLanguageState(theValue);
            break;
          case 'birthPlace':
            setBirthPlaceState(theValue);
            break;
          case 'birthDate':
            setBirthDateState(theValue);
            break;
          default:
            break;
        }
      
      //setErrorState(errorTemp);
    }
  }

  /**
   * Retourne le jsx du component
   */
  let listInput = getInput();
  return (
    <>
      { props.hasBookingCheckInState.hasBookingCheckIn && 
        <Message info>
          <p>{globalContext.translations.someNoModifInformation}</p>
        </Message>
      }
      
      <Form id="form-personnal-information">
        {renderRedirectAccount()}
        <Form.Group widths="equal">
          <InputSelect
            label={globalContext.translations.civility}
            name={listInput.civility.name}
            value={civilityState}
            data={listOptionsState.civilitys}
            required={listInput.civility.required}
            labelError={globalContext.translations.enterIndicatifAndNumberPhone}
            typePattern={listInput.civility.typePattern}
            error={errorState.civility?.error}
            disabled={listInput.civility.disabled}
          />
          <InputText
            label={globalContext.translations.society}
            name={listInput.society.name}
            value={societyState}
          />
        </Form.Group>

        <Form.Group widths="equal">
          <InputText
            label={globalContext.translations.lastName}
            name={listInput.lastName.name}
            value={lastNameState}
            required={listInput.lastName.required}
            labelError={globalContext.translations.enterNom}
            typePattern={listInput.lastName.typePattern}
            error={errorState.lastName}
            disabled={listInput.lastName.disabled}
          />
          <InputText
            label={globalContext.translations.firstName}
            name={listInput.firstName.name}
            value={firstNameState}
            required={listInput.firstName.required}
            labelError={globalContext.translations.enterPrenom}
            typePattern={listInput.firstName.typePattern}
            error={errorState.firstName}
            disabled={listInput.firstName.disabled}
          />
        </Form.Group>

        <Form.Group widths="equal">
          <InputSelect
            label={globalContext.translations.nationality}
            name={listInput.nationality.name}
            value={nationalityState}
            data={listOptionsState.nationalities}
            search={!isMobile}
            flag
            required={listInput.nationality.required}
            labelError={globalContext.translations.enterNationalite}
            typePattern={listInput.nationality.typePattern}
            error={errorState.nationality?.error}
            className={"testStyle"}
            disabled={listInput.nationality.disabled}
          />
          <InputSelect
            label={globalContext.translations.language}
            name={listInput.language.name}
            value={languageState}
            data={listOptionsState.languages}
            flag
            required={listInput.language.required}
            labelError={globalContext.translations.enterLangue}
            typePattern={listInput.language.typePattern}
            error={errorState.language?.error}
            disabled={listInput.language.disabled}
          />

        </Form.Group>

        <Form.Group widths="equal">
          <InputText
            label={globalContext.translations.cityOfBirth}
            name={listInput.birthPlace.name}
            value={birthPlaceState}
            required={listInput.birthPlace.required}
            labelError={globalContext.translations.enterVille}
            typePattern={listInput.birthPlace.typePattern}
            error={errorState.birthPlace}
            readonly={listInput.birthPlace.disabled}
          />
          <InputSelectDate
            label={globalContext.translations.birthDate}
            name={listInput.birthDate.name}
            value={birthDateState}
            required={listInput.birthDate.required}
            search={!isMobile}
            labelError={globalContext.translations.enterBirthDate}
            error={errorState.birthDate}
            readonly={listInput.birthDate.disabled}
          />
        </Form.Group>

        <Form.Field className="mt-5">
          <Button
            positive
            className="mx-auto d-block"
            content={globalContext.translations.next}
            icon="right arrow"
            labelPosition="right"
            onClick={handleSubmit}
          />
        </Form.Field>
      </Form>
    </>
  );
}

export default FormPersonalInformation